export const TREND_DIRECTION_LABEL_BY_VALUE = {
    [-1]: 'down',
    [0]: 'stable',
    [1]: 'up'
};


export const TREND_DIRECTION_VALUES = Object.keys(TREND_DIRECTION_LABEL_BY_VALUE)
    .map(entry => parseInt(entry, 10));
